<div class="container">
  <h3 class="text-primary ab_left_text">FILE DOCK
  </h3>
  <blockquote class="generic-blockquote">
    This is a feature upon activation by each user warehouses all generated files and also files uploaded by a user. It
    entails features to transfer files between users.
  </blockquote>
</div>